import { render, staticRenderFns } from "./school_video.vue?vue&type=template&id=99b4682a&"
import script from "./school_video.vue?vue&type=script&lang=js&"
export * from "./school_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports